import React from 'react';
// @ts-ignore
export const ShuttleContext = React.createContext({});
